/* global jQuery, elementorFrontend, ScrollMagic, js_vars, Mmenu */
( function( $ ) {
	/**
	 * @param $scope The widget wrapper element as a jQuery element
	 * @param $ The jQuery alias
	 */

	 const siteWidth = 1400,
	 mobileWidth = 768;
	 
	$( window ).on( 'elementor/frontend/init', function() {

		/*--------------------------------------------------------------------------------
		Utility: Hide element on click outside
		--------------------------------------------------------------------------------*/

		function hideOnClickOutside( selector ) {
			const outsideClickListener = ( event ) => {
				const $target = $(event.target);
				if( ! $target.closest(selector).length && $(selector).is(':visible') ) {
					$(selector).removeClass('open');
					removeClickListener();
				}
			}

			const removeClickListener = () => {
				document.removeEventListener('click', outsideClickListener)
			}

			document.addEventListener('click', outsideClickListener)
		}


		/*--------------------------------------------------------------------------------
		Crosslin Testimonial Carousel Widget
		--------------------------------------------------------------------------------*/

		elementorFrontend.on('components:init', function() {
			const asyncSwiper = elementorFrontend.utils.swiper;
			$('.crosslin-linkcards.linkcards--horizontal .swiper-container').each(function() {
				let $this = $(this);
				// let $image = $this.parents('.crosslin-testimonialcarousel').find('.testimonialcarousel__image img');

				let swiperPadding = Math.max(20, ($(document).outerWidth() - siteWidth) / 2);
				$this.css('paddingLeft', swiperPadding);
				
				if( $this && $this.find('.swiper-slide').length > 1 ) {
					let swiperSettings = {
						allowTouchMove: true,
						// autoHeight: true,
						centeredSlides: false,
						loop: false,
						slidesPerView: 1.5,
						spaceBetween: 36,
						breakpoints: {
							620: {
								slidesPerView: 2.5
							},
							768: {
								slidesPerView: 3.5
							},
							1080: {
								slidesPerView: 4.5
							}
						},
					};
					window.carouselSwiper = new asyncSwiper(jQuery($(this)), swiperSettings);
				}
			});
		});

		$(window).resize(function() {
			let swiperPadding = Math.max(20, ($(document).outerWidth() - siteWidth) / 2);
			$('.crosslin-linkcards.linkcards--horizontal .swiper-container').css('paddingLeft', swiperPadding);
		});


		/*--------------------------------------------------------------------------------
		Accordion
		--------------------------------------------------------------------------------*/

		$('.crosslin-accordion .accordion-entry .entry__title').click(function(e){
			e.preventDefault();

			$(this).parents('.accordion-entry').toggleClass('open');
		});


		/*--------------------------------------------------------------------------------
		Livesearch
		--------------------------------------------------------------------------------*/

		elementorFrontend.on('components:init', function() {

			// Reset form on load
			let searchForm = document.getElementById("live-search-form");
			if( searchForm) {
				searchForm.reset();
			}

			// Prep for future direct-link resource filtering
			const url = new URL(window.location);
			const params = new URLSearchParams(url.search);

			// Manage search form submissions
			$(document).on('submit', '#live-search-form', function(e) {
				e.preventDefault();
				_submit_live_search( $(this) );
			});

			// Manage load more button
			$(document).on( 'click', '#loadmore', function(e) {
				e.preventDefault();

				var search_data = $('#live-search-form').serializeArray();
				var search_perpage = $('#live-search-form').data('perpage');
				var search_template = $('#live-search-form').data('view');
				var search_type = $('#live-search-form').data('searchtype');
				var page = $(this).data('page');

				if ( doAction ) {
					clearTimeout( doAction );
				}

				doAction = setTimeout( function() {
					_do_live_search(search_data, page, search_type, search_template, search_perpage);
				}, 250 );
			});
		});

		elementorFrontend.on('components:init', function() {
			const asyncSwiper = elementorFrontend.utils.swiper;
			$('.elementor-widget-crosslin-livesearch.horizontal-scroll-yes .swiper-container').each(function() {
				let $this = $(this);

				let swiperPadding = Math.max(20, ($(document).outerWidth() - siteWidth) / 2);
				$this.css('paddingLeft', swiperPadding);
				
				if( $this && $this.find('.card-entry').length > 1 ) {
					let swiperSettings = {
						allowTouchMove: true,
						// autoHeight: true,
						centeredSlides: false,
						loop: false,
						slidesPerView: 1.125,
						spaceBetween: 36,
						breakpoints: {
							620: {
								slidesPerView: 2.25
							},
							768: {
								slidesPerView: 2.5
							},
							1080: {
								slidesPerView: 3.25
							}
						},
					};
					window.postsSwiper = new asyncSwiper(jQuery($(this)), swiperSettings);
				}
			});
		});

		$(window).resize(function() {
			let swiperPadding = Math.max(20, ($(document).outerWidth() - siteWidth) / 2);
			$('.elementor-widget-crosslin-livesearch.horizontal-scroll-yes .swiper-container').css('paddingLeft', swiperPadding);
		});






	});



	/*--------------------------------------------------------------------------------
	Manage live search functionality
	--------------------------------------------------------------------------------*/
	
	let doAction = false,
	willDestroy = true,
	ajaxOn = 'inactive';

	function _submit_live_search( $form ) {
		var search_ctaid = $('#live-search-form').data('ctaid');
		var search_data = $form.serializeArray();
		var search_perpage = $form.data('perpage');
		var search_template = $form.data('view');
		var search_term = $('#live-search').val();
		var search_type = $form.data('searchtype');

		if( doAction ) {
			clearTimeout( doAction );
		}

		doAction = setTimeout( function() {
			_do_live_search(search_data, 1, search_type, search_template, search_perpage, search_ctaid);
		}, 250 );
	}

	// Execute search
	function _do_live_search(search_data, page = 1, search_type = '', template = 'card', perpage = 8, cta_id = 0) {
		// Exit if AJAX is currently running
		if ( ajaxOn == 'active' ) { return false; }

		$('.live-search-container').addClass('processing');

		// Run AJAX search
		ajaxOn = 'active';
		$.when( _ajax( search_data, page, search_type, template, perpage, cta_id ) ).done(function( response ) {
			// Handle post-search cleanup & display
			_do_after_search(search_data, response, page, template);
		});
	}

	// Process AJAX
	function _ajax( search_data, page = 1, search_type, template = 'card', perpage = 8, cta_id = 0 ) {
		var data = {
			action: 'hw_ajax_search',
			cta_id: cta_id,
			page: page,
			perpage: perpage,
			settings: search_data,
			searchtype: search_type,
			template: template
		};

		return $.ajax({
			type: 'POST',
			url: js_vars.ajaxurl,
			data: data,
			success: function(response) {
				// console.log(response);
				ajaxOn = 'inactive';
			},
			error: function(error) {
				console.log('error');
				ajaxOn = 'inactive';
			}
		});
	}

	// Handle results after search
	function _do_after_search(data, response, page = 1, template = 'card') {
		$('.live-search-container').removeClass('processing');

		_build_results(data, response, page, template);
		doAction = false;
	}

	// Destroy search results and/or button
	function _destroy( page = 1 ) {
		if( page !== 1 ) {
			$('#loadmore').remove();
		} else {
			$('#live-search-results').empty();
		}
	}

	// Display results
	function _build_results(search_data, response, page = 1, template = 'card') {
		if ( response.results.length > 0 ) {
			_destroy( page );
			let number_results = ( response.numberposts < response.perpage ) ? response.numberposts : ( response.perpage * page );
			$('.live-search-count').text('Showing ' + number_results + ' of ' + response.numberposts + ' results');

			$('#live-search-results').append(response.results);

			if( response.pagination.more ) {
				$('#live-search-loadmore').html('<a id="loadmore" href="#" data-page="' + response.pagination.page + '">Load More</a>');
			} else {
				$('#live-search-loadmore').html('');
			}
		} else {
			_destroy();
			$('.live-search-count').text('');
			$('#live-search-results').append('<p>No results found.</p>');
			$('#live-search-loadmore').html('');
		}

		$('#filters__active').html(response.active_filters);
		if( response.active_filter_count > 0 ) {
			$('#mobile-filters__clear').text('Clear (' + response.active_filter_count + ')');

			if( $('#clear-button--mobile').length ) {
				$('#clear-button--mobile').html('Clear (' + response.active_filter_count + ')');
			} else {
				$('#mobile-filter-controls').append('<a id="clear-button--mobile" class="clear-button--mobile" href="#">Clear (' + response.active_filter_count + ')</a>');
			}
		} else {
			$('#clear-button--mobile').remove();
			$('#mobile-filters__clear').text('Clear');
		}

		// Recalculate sticky header defined in theme, if necessary
		if( window.stickyHeader ) {
			window.stickyHeader.update();
		}
	}
	

} )( jQuery );


